"use client";

/**
 * Root-mounted host for the payments-paused pop-up. Subscribes to the imperative
 * store so any pay handler anywhere in the app can open it with a single
 * `interceptIfPaymentsPaused(...)` call and no local modal state.
 *
 * Lives next to <PurchaseConfirmationHost /> in app/layout.tsx — the two are
 * opposite ends of the same flow (a purchase that completed vs one we could not
 * take), and both need to be reachable from every surface.
 */
import {
  dismissPaymentsPaused,
  usePaymentsPaused,
} from "./payments-paused-store";
import { PaymentsPausedModal } from "./payments-paused-modal";

export function PaymentsPausedHost() {
  const request = usePaymentsPaused();
  if (!request) return null;
  return (
    <PaymentsPausedModal
      // Re-mount per request id so a second blocked purchase in the same session
      // replays the entrance animation and re-reads the intent.
      key={request.id}
      request={request}
      onDismiss={dismissPaymentsPaused}
    />
  );
}
